import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { UpdateBonusAssignmentResponse, UpdateBonusAssignmentVariables } from '../types';

export const updateBonusAssignmentMutation = gql`
  mutation PayrollUpdateBonusAssignment($input: UpdateBonusAssignmentInput!) {
    payrollUpdateBonusAssignment(input: $input) {
      code
      success
      message
      data {
        id
      }
    }
  }
`;

export const updateBonusAssignment = (queryVariables: UpdateBonusAssignmentVariables) =>
  graphQLApi<UpdateBonusAssignmentResponse, UpdateBonusAssignmentVariables>({
    query: updateBonusAssignmentMutation,
    queryVariables,
  });

export default updateBonusAssignment;
